import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luSession = {
  state: {
    luSessions: [],
    selectedLuSession: {},
    selectedLuSessionOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luSessions(state) {
      return state.luSessions
    },
    selectedLuSession(state) {
      return state.selectedLuSession
    },
    selectedLuSessionOriginal(state) {
      return state.selectedLuSessionOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luSessions(state, payload) {
      state.luSessions = payload
    },
    selectedLuSession(state, payload) {
      state.selectedLuSession = JSON.parse(JSON.stringify(payload))
    },
    selectedLuSessionOriginal(state, payload) {
      state.selectedLuSessionOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuSession(context, payload) {
      context.commit('selectedLuSession', payload)
    },
    async loadLuSessions(context, payload) {
      const url = 'LuSession'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luSessions', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async refreshSelectedLuSession(context, payload) {
      if (
        context.state.selectedLuSession &&
        context.state.selectedLuSession.Id > 0
      ) {
        return await context.dispatch(
          'loadSelectedLuSession',
          context.state.selectedLuSession.Id
        )
      }
    },
    async loadSelectedLuSession(context, payload) {
      if (
        context.state.selectedLuSession &&
        context.state.selectedLuSession.Id != payload
      ) {
        context.commit('selectedLuSession', {})
      }
      const url = 'LuSession/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedLuSession', res.data)
        context.commit('selectedLuSessionOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async clearLookupCacheAndReloadLuSessions(context, payload) {
      await caches.delete('apilookup-cache')
      return await context.dispatch('loadLuSessions')
    },
    async createLuSession(context, payload) {
      const url = `LuSession`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'session created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuSessions')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchLuSession(context, payload) {
      var item = context.state.selectedLuSession
      if (
        payload.Id &&
        payload.Id == context.state.selectedLuSessionOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedLuSessionOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `LuSession/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'session updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadLuSessions')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateLuSession(context, payload) {
      const url = `LuSession/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'session updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuSessions')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveLuSession(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateLuSession', payload)
      } else {
        return context.dispatch('createLuSession', payload)
      }
    },
    async deleteLuSession(context, payload) {
      const url = `LuSession/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'session deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuSessions')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luSession
